import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import styled from 'styled-components';

import { Form, Radio, Row, Col, Icon } from 'antd';
import Router, { useRouter } from 'next/router';
import _ from 'lodash';
import { useSetAtom } from 'jotai';
import { useMutation } from '@apollo/react-hooks';
import { useResetAtom } from 'jotai/utils';

import Layout from '../../components/Layout';
import Container from '../../components/Container';

import * as Queries from './queries';
import * as DiagnosisReportQueries from '../diagnosisReport/queries';
import * as AuthQueries from '../auth/queries';

import * as Constants from './constants';

import DiagnosisBasicInfo from '../../components/diagnosis/BasicInfo';
import DiagnosisKidney from '../../components/diagnosis/Kidney';
import DiagnosisDiabetes from '../../components/diagnosis/Diabetes';
import DiagnosisCancer from '../../components/diagnosis/Cancer';
import DiagnosisLowsalt from '../../components/diagnosis/Lowsalt';

import kidneyBI from '../../assets/images/kidney_BI.png';
import cancerBI from '../../assets/images/cancer_BI.png';
import diabetsBI from '../../assets/images/diabets_BI.png';
import LowSaltStringInput from '../../components/diagnosis/LowSaltStringInput';
import GFRQuestion from '../../components/diagnosis/GFRQuestion';

import { usePayload, useDiseaseArray, useCalculator, useResetAllDiagnosis } from './hooks';
import { diagnosisBaseAtom, diseaseAtom, kidneyAtom, payloadAtom, requestDiseaseAtom, gfrAtom, mealNameClassification } from '../../components/diagnosis/atom';
import { useAtomValue } from 'jotai';

import Calculator from './calculator';

const { nutritionCalculator } = Calculator();

// const [createRecordInput] = useMutation(Queries.CREATE_RECORD_INPUT);

const inputMessage = '잠깐만요! 정확히 입력해주세요.';
const radioButtonMessage = '잠깐만요! 반드시 선택해주세요.';

const diseaseDesignStyle = {
  kidney: {
    color: '#FF5100',
    image: kidneyBI
  },
  diabetes: {
    color: '#00ABE4',
    image: diabetsBI
  },
  cancer: {
    color: '#45ac34',
    image: cancerBI
  }
};

// 건강정보 입력 컴포넌트
const Diagnosis = props => {
  const {
    data: {
      auth: { isLoggedIn }
    }
  } = useQuery(AuthQueries.AUTH);

  const [createRecordInput] = useMutation(Queries.CREATE_DISEASE_HEALTH_RECORD);

  const [complete, setComplete] = useState('다음');
  // # client state
  const { getFieldDecorator } = props.form;

  const router = useRouter();

  const [color, setColor] = useState('');

  const [biImg, setBiImg] = useState(null);
  // const { payload, setPayload, resetPayload, handleSelectionClick, handleInputBoxChange } = usePayload();
  // const [diagnosisBase, setPayload] = useAtom(diagnosisBaseAtom);
  // const { diseaseArray, diseaseSelections, setDiseaseSelections, handleSelectionDiseaseClick } = useDiseaseArray();
  let disease = useAtomValue(diseaseAtom);

  useEffect(() => {
    if (disease === 'loading') return;
    setColor(diseaseDesignStyle[disease]?.color || diseaseDesignStyle.kidney.color);
    setBiImg(diseaseDesignStyle[disease]?.image || diseaseDesignStyle.kidney.image);
  }, [disease]);
  const setRequestDisease = useSetAtom(requestDiseaseAtom);

  useEffect(() => {
    setRequestDisease(router.query.disease);
    if (router.query.custom_price) {
      sessionStorage.setItem('custom_price', router.query.custom_price);
    }
    return () => {
      sessionStorage.removeItem('custom_price');
    };
  }, [router.query]);

  const [error, setError] = useState('');
  const [errorStateExist, setErrorState] = useState(null);
  const payload = useAtomValue(payloadAtom);
  const mealName = useAtomValue(mealNameClassification);
  const resetAllDiagnosis = useResetAllDiagnosis();

  const handleSubmitClick = async e => {
    e.preventDefault();
    try {
      props.form.validateFieldsAndScroll(async err => {
        if (!err) {
          const caluclatedValue = nutritionCalculator(disease, payload.height, payload.gender, payload.kidney.kidneyStatus, payload.diabetes.diabetesStatus, payload.diabetes.pregnantStatus);
          const newPayload = {
            ...payload,
            cancer: {
              ...payload.cancer,
              cancerCategorySet: JSON.stringify([...payload.cancer.cancerCategorySet]),
              anotherDiseaseSet: JSON.stringify([...payload.cancer.anotherDiseaseSet])
            }
          };
          const response = await createRecordInput({ variables: { disease, mealName, inputData: JSON.stringify(newPayload), resultData: JSON.stringify(caluclatedValue) } });
          resetAllDiagnosis();
          setError('');
          setComplete(<Icon type="loading" style={{ fontSize: 24 }} spin />);
          localStorage.setItem('diseaseData', JSON.stringify(response));
          router
            .push({
              pathname: '/diagnosis-report',
              query: {
                ...(sessionStorage.getItem('custom_price') && { custom_price: true })
              }
            })
            .then(() => {
              window.scrollTo(0, 0);
            });
        } else {
          setErrorState(err);
          console.log('errors', err);
        }
      });
    } catch (err) {
      setError(
        <>
          정확한 정보를 입력하지 않았거나 문제가발생했습니다.
          <br /> 채팅 혹은 대표번호(1899-9708)로 연락주세요!
        </>
      );
    }
  };

  return (
    <Layout isOrder withFooter={false} step={1} backgroundColor="#f8f8f8">
      <StyledContainer color={color}>
        <Row>
          <EatmaplBi>
            <img src={biImg} alt="잇마플BI" style={{ height: '16rem' }} />
          </EatmaplBi>
          <Line />
          <Col span={24} md={24}>
            <Title>
              고객님이 입력하신 건강 정보를 토대로 <br />
              맞춤 식단이 만들어집니다.
            </Title>
            <Description>
              * 영양 진단을 위해 정확한 정보를 입력해주세요 <b>(약 3분 소요)</b>
              <br />* 임상영양사와 영양상담 시 활용됩니다
            </Description>
          </Col>
        </Row>
        <Row>
          <Col span={0} md={5} />
          <Col span={24} md={14}>
            <Form onSubmit={handleSubmitClick}>
              <DiagnosisBasicInfo getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} inputMessage={inputMessage} />
              {/* 식단선택 */}
              {disease === 'kidney' && <DiagnosisKidney disease="kideny" getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} inputMessage={inputMessage} color={color} />}
              {disease === 'kidney_trial' && (
                <DiagnosisKidney disease="kidney_trial" getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} inputMessage={inputMessage} color={color} />
              )}
              {disease === 'diabetes' && <DiagnosisDiabetes getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} inputMessage={inputMessage} color={color} />}
              {disease === 'cancer' && <DiagnosisCancer getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} inputMessage={inputMessage} color={color} />}
              {disease === 'lowsalt' && <DiagnosisLowsalt getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} />}
              <LowSaltStringInput getFieldDecorator={getFieldDecorator} inputMessage={inputMessage} />
              <GFRQuestion />
              <Error>{error && error}</Error>
              <Submit onClick={handleSubmitClick}>{complete}</Submit>
            </Form>
          </Col>
          <Col span={0} md={5} />
        </Row>
      </StyledContainer>
    </Layout>
  );
};

const Error = styled.div`
  font-size: 1.4rem;
  font-weight: bold;
  color: tomato;
  margin-bottom: 1rem;
`;
const StyledContainer = styled(Container)`
    padding:0 1rem;
  text-align: center;
  padding-top: 5rem;
  ${props => props.theme.device.md} {    
    display: block;
    padding: 10rem 0;
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    /* color: #fff; */
    color: ${props => props.color};
    /* background: ${props => props.color}; */
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    /* background: ${props => props.color}; */
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    /* background-color: ${props => props.color}; */
    /* border-color: ${props => props.color}; */
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    box-shadow: none;
    /* background-color: ${props => props.color};*/
    background-color:#ededed ;
    color: ${props => props.color};
    /* border-color: ${props => props.color}; */
    border-color:#d9d9d9 ;
  }
`;
const Question = styled.div`
  margin-bottom: 7rem;
  width: 100%;
  .notice {
    width: 100%;
    display: flex;
    justify-content: center;
    p {
      width: 80%;
      font-size: 1.2rem;
    }
  }

  ${props => props.theme.device.md} {
    margin-bottom: 6rem;
    .notice {
      p {
        width: 100%;

        font-size: 1.5rem;
      }
    }
  }
`;
const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;
const KidneyStatusSection = styled(RelayionTypeSection)``;

const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;

const Title = styled.div`
  word-break: keep-all;
  font-size: 2rem;
  color: #323232;
  text-align: center;
  ${props => props.theme.device.md} {
    font-size: 3rem;
    word-break: keep-all;
  }

  span {
    color: #2f6ecd;
  }
`;

const Description = styled.div`
  word-break: keep-all;
  font-size: 1.3rem;
  color: #808080;
  margin-top: 2rem;
  ${props => props.theme.device.md} {
    font-size: 2rem;
    font-weight: 400;
  }
`;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;

const Submit = styled.button`
  font-size: 2.2rem;
  font-weight: 700;
  color: white;
  background: #ff9d46;
  width: calc(100%);
  margin-left: -2rem;
  margin-right: -2rem;
  height: 6.4rem;
  border: 0;
  padding: 0;

  ${props => props.theme.device.md} {
    font-size: 2.4rem;
    height: 8rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 62rem;
    margin: 0rem auto;
    cursor: pointer;
  }
`;

const EatmaplBi = styled.div`
  width: 100%;
  margin-bottom: 4rem;
  ${props => props.theme.device.md} {
    margin-bottom: 6.5rem;
  }
`;

const Line = styled.hr`
  border: 1px solid #cecece;
  width: 32px;
  margin-bottom: 4rem;
  ${props => props.theme.device.md} {
    width: 50px;
    margin-bottom: 6.5rem;
  }
`;

export default Form.create()(Diagnosis);

// 인풋
// 다중선택
// 단일선택(라디오) + 없음
